import React from 'react';
import { Box, Typography } from '@mui/material';
import { Webhook } from '@mui/icons-material';

/**
 * Empty state component displayed when no events are available
 */
const EventsEmptyState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: 4,
        textAlign: 'center',
      }}
    >
      <Webhook
        sx={{
          fontSize: 80,
          color: 'text.disabled',
          marginBottom: 3,
          opacity: 0.5,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: 'text.secondary',
          marginBottom: 1,
          fontWeight: 500,
        }}
      >
        No Webhook Events
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          maxWidth: '400px',
        }}
      >
        Events triggered to your configured url will appear here.
      </Typography>
    </Box>
  );
};

export default EventsEmptyState;
